import { render, staticRenderFns } from "./AppStep5.vue?vue&type=template&id=5c4ceb90"
import script from "./AppStep5.vue?vue&type=script&lang=js"
export * from "./AppStep5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports